<template class="rows_container">
  <div class="row result_row" :id="'entityRow_' + index">

		<div class="col-xl-2 col-lg-2 col-md-2 col-sm-4 thumbnail_section">
			<b-btn class="thumbnail_container ace_sec" role="button" :class="'th_' + source.uuid + ' ' + source.type" @click.stop="parent.goToProgramGuideDetail(source)" :aria-label="source.title + ' thumbnail'">
				<div class="program_type">
					<span class="ic_program_type" v-if="source.type === 'MINOR'" title="Minor">m</span>
					<span class="ic_program_type" v-if="source.type === 'CERT'" title="Certificate">c</span>
					<span class="ic_program_type" v-if="source.type === 'WFT'" title="Workforce Training">w</span>
				</div>
				<div class="thumbnail_img" v-if="source.thumbnailURL" :class="parent.setImageBgColor(source.thumbnailURL)">
				  <img v-bind:src="source.thumbnailURL" :alt="source.title + ' Thumbnail'">
				</div>
				<div v-else class="thumbnail_default ico-degreeProgram"></div>
			</b-btn>
		</div>

		<div class="col-xl-6 col-lg-6 col-md-5 col-sm-8 entity_detail_section" :class="parent.updateTitleHeight(index)">
			<div class="row">
				<div class="col-12 title_row">
          <span class="title ace_sec_txt" :aria-label="source.title" v-on:mouseover="parent.checkTitleLength(index)">
            <b-link class="title_txt" :id="'entityName_' + index" role="button" href="#" @click.stop="parent.goToProgramGuideDetail(source, index)">{{source.title}}</b-link>
          </span>
          <template v-if="isBookmarkEnabled">
            <span
              v-if="parent.showBookmarkOnResult && parent.isBookmarked(source)"
              @click.stop.prevent="parent.deleteProgramGuideBookmark(source)"
              class="ic_bm_container bookmarked ace_sec_txt"
              title="remove this program from bookmark">
                <span class="ic8-bookmark3"></span>
            </span>
            <span
              v-else-if="parent.showBookmarkOnResult && !parent.isBookmarked(source)"
              @click.stop.prevent="parent.bookmarkProgramGuide(source)"
              class="ic_bm_container ace_sec_txt"
              title="bookmark this program">
                <span class="ic8-bookmark3"></span>
            </span>
          </template>
          <!--
					<span class="icon icon-programGuide"></span>
          -->

          <template v-if="parent.titlePopoverEnabled">
            <b-popover :target="'entityName_' + index" triggers="hover" placement="top" class="title_popup" :container="'entityNameContainer_' + index">
  						<div class="title_container">
  						  {{source.title}}
  						</div>
  					</b-popover>
  					<div :id="'entityNameContainer_' + index" class="title_container_popup"></div>
          </template>

				</div>

        <template v-if="parent.showDescriptionOnResult && source.description">
          <div class="col-12 description ace_sec_txt" :id="'entityDesc_' + index">
            <span class="desc_txt" v-html="source.description"></span>
          </div>
          <div class="col-12 more_lnk_container_v7" style="margin-left: auto;" :class="parent.showMoreDescLnk(index)">
            <b-btn class="btn_lnk" v-b-modal="'entityDescModal_' + index" aria-label="show complete description">
              more
            </b-btn>
          </div>
        </template>

        <template v-else-if="parent.showDescriptionOnResult && !source.description">
          <div class="col-12 no_description empty_pattern ace_sec_txt" aria-label="No description added for this program">
            No description added for this program
          </div>
        </template>

        <template v-if="parent.showDescriptionOnResult && source.description">

          <b-modal size="xl" :id="'entityDescModal_' + index" :title="source.title" ok-only ok-title="close">

            <div class="row">

              <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 thumbnail_section">
                <div class="thumbnail_container ace_sec" :class="'th_' + source.uuid + ' ' + source.type" @click.stop="parent.goToProgramGuideDetail(source)" :aria-label="source.title + ' thumbnail'">
                  <div class="program_type">
                    <span class="ic_program_type" v-if="source.type === 'MINOR'" title="Minor">m</span>
                    <span class="ic_program_type" v-if="source.type === 'CERT'" title="Certificate">c</span>
                    <span class="ic_program_type" v-if="source.type === 'WFT'" title="Workforce Training">w</span>
                  </div>
                  <div class="thumbnail_img" v-if="source.thumbnailURL" :class="parent.setImageBgColor(source.thumbnailURL)">
                    <img v-bind:src="source.thumbnailURL" alt="Img">
                  </div>
                  <div v-else class="thumbnail_default ico-degreeProgram"></div>
                </div>
              </div>

              <div class="col-xl-8 col-lg-8 col-md-8 col-sm-12">

                <div class="row">
                  <div class="col-12 description">
                    <span class="desc_txt" v-html="source.description"></span>
                  </div>

                  <div class="col-12" v-if="institution.uuid!==source.institutionId">
                    <div class="row list_info_row inst_name">
                        <div class="col-2 info_title">
                          institution
                        </div>
                        <div class="col-10 info_val">
                         {{ getAssociatedInstitutionName(source.institutionId) }}
                       </div>
                    </div>
                  </div>
              </div>

              </div>

            </div>

          </b-modal>
        </template>


        <div class="col-12" v-if="institution.uuid!==source.institutionId">
          <div class="row list_info_row inst_name">
              <div class="col-2 info_title">
                institution
              </div>
              <div class="col-10 info_val">
               {{ getAssociatedInstitutionName(source.institutionId) }}
             </div>
          </div>
        </div>

        <div class="col-12">
          <div class="row">

            <div class="col-10">

              <div class="row">
                <template v-if="parent.showProgramTypeTagOnResult">
                  <div class="col-12 program_type_tag">
                    <span class="tag ace_sec_txt" v-if="source.type === 'MINOR'">Minor</span>
                    <span class="tag ace_sec_txt" v-if="source.type === 'CERT'">Certificate</span>
                    <span class="tag ace_sec_txt" v-if="source.type === 'WFT'">Workforce Training</span>
                  </div>
                </template>

                <div class="col-12 program_price">
                  <div class="info_val ace_sec_txt price_sec" v-if="source.lowestPrice" :aria-label="'Price is ' + source.lowestPrice + ' for this program'">
                    <b-link class="more-link" @click.stop="parent.goToProgramGuideDetail(source, index)" v-if="parent.alreadyPurchased(source)">subscribed</b-link>
                    <b-link class="more-link" @click.stop="parent.goToProgramGuideDetail(source, index)" v-else>Price is <span v-if="source.lowestPriceCurrency === 'usd'">$</span> {{source.lowestPrice}} - buy</b-link>

                  </div>
                  <div class="info_val ace_sec_txt cost_sec" v-else-if="source.cost" :aria-label="'Cost ' + source.cost + ' for this program guide'">
                    <span class="cost"> Cost ${{parent.addCommaInNumber(source.cost)}} </span>
                  </div>
                  <div class="filters_tag_row ace_sec_txt">
                    <span class="filter_tag" v-if="source.modalityType" :aria-label="'modalityType  ' + source.modalityType + ' for this program'" > {{parent.getModalityValue(source.modalityType)}} </span>
                    <span class="filter_tag" v-if="source.fundingType" :aria-label="'fundingType  ' + source.fundingType + ' for this program'" > {{parent.getFundingValue(source.fundingType)}} </span>
                    <span class="filter_tag" v-if="!source.freeProgram && source.pragyaProgram && source.lowestPrice === 0 && !source.paymentProcessedOutOfPragya" aria-label="program is coming soon" >Coming Soon</span>
                  </div>
                </div>

              </div>

            </div>

          </div>
        </div>

      </div>
		</div>

		<div class="col-xl-4 col-lg-4 col-md-5 col-sm-12 other_info">
			<div class="row" v-if="!source.disableLMI">
				<div v-if="parent.showMedianIncomeOnResult" class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">

					<div class="info_title">{{parent.medianIncomeResultLabel}} </div>
					<div class="info_val ace_sec_txt" v-if="source.medianIncomePerYear" :aria-label="'median income is ' + parent.currencyLabel + source.medianIncomePerYear + ' for this program guide'">
					  {{parent.currencyLabel}}<span v-html="parent.addCommaInNumber(source.medianIncomePerYear)"></span>
					</div>
					<div class="info_no_val ace_sec_txt" v-else aria-label="median income is not available for this program guide">N/A</div>
				</div>

				<div v-if="parent.showJobPostingsOnResult" class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
					<div class="info_title">{{parent.jobPostingsResultLabel}}</div>
					<div class="info_val ace_sec_txt" v-if="source.totalJobPostings" :aria-label="'job postings are ' + source.totalJobPostings + ' for this program guide'">
						<span v-html="parent.addCommaInNumber(source.totalJobPostings)"></span>
					</div>
					<div class="info_no_val ace_sec_txt" v-else aria-label="job postings are not available for this program guide">N/A</div>
				</div>

				<div v-if="parent.showGrowthRateOnResult" class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
					<div class="info_title">{{parent.growthRateResultLabel}}</div>
					<div class="info_val ace_sec_txt" v-if="source.growthRate" :aria-label="'Growth rate is ' + source.growthRate + ' for this program guide'">
						<span v-html="(Math.round(source.growthRate * 100) / 100).toFixed(1)"></span>%
					</div>
					<div class="info_no_val ace_sec_txt empty_pattern" v-else aria-label="growth rate is not available for this program guide">N/A</div>
				</div>


        <div v-if="parent.showCalculateRequiredCreditOnResult && parent.isStudentLogin && parent.planningStream" class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
          <span class="lnk_req_credit ace_sec_txt"
            :id="'creditProgressPopup_' + source.uuid"
            @click="parent.calculateCreditProgressClicked(source)">
            <template v-if="parent.showTransferredCoursesCreditProgress && parent.allProgramProgress[source.uuid]">
              <template v-if="parent.isShowCourseProgressEnabled">
                <b-btn style="width: 225px; padding: 0;">
                  <b-progress :max="100" height="27px" style="cursor: pointer; margin-top: -4px;">
                    <b-progress-bar :value="100" style="background-color: #ddd !important;">
                      <span style="font-size: 16px; color: #8cbc3f;"><b>{{parent.allProgramProgress[source.uuid].transferredCourses}} out of {{parent.allProgramProgress[source.uuid].totalCourses}} credits</b></span>
                    </b-progress-bar>
                  </b-progress>
                </b-btn>
              </template>
              <template v-else>
                <b-btn style="width: 225px; padding: 0;">
                  <b-progress :max="100" height="27px" style="cursor: pointer; margin-top: -4px;">
                    <b-progress-bar :value="100" style="background-color: #ddd !important;">
                      <span style="font-size: 16px; color: #8cbc3f;"><b>{{parent.allProgramProgress[source.uuid].transfered}} out of {{parent.allProgramProgress[source.uuid].total}} credits</b></span>
                    </b-progress-bar>
                  </b-progress>
                </b-btn>
              </template>
            </template>
            <template v-else>
              Calculate Required Credits
            </template>
          </span>
        </div>

				<!--
				<div class="col-xl-12 col-lg-12 col-md-12 col-sm-4 list_info_row">
					<div class="info_title">growth rate</div>
					<div class="info_val ace_sec_txt" v-if="source.growthRate" :aria-label="'growth rate is ' + source.growthRate + ' % for this program guide'">{{source.growthRate}} %</div>
					<div class="info_no_val ace_sec_txt empty_pattern" v-else aria-label="growth rate is not available for this program guide">N/A</div>
				</div>
				-->
			</div>
		</div>

  </div>
</template>

<script>
import { PACKAGE } from '../../../package_constants'
import { PackageUtil } from '../../../package_utils'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'programGuideItem',
  props: {
    parent: {
      type: Object
    },
    index: {
      type: Number
    },
    source: {
      type: Object,
      default () {
        return {}
      }
    }
  },
 methods: {
      ...mapActions([
      ]),

    getAssociatedInstitutionName (uuid) {
      if(!this.associatedInstitutions){
          return 'N/A'
      }
      for(var i=0;i<this.associatedInstitutions.length; i++){
          if(this.associatedInstitutions[i].uuid===uuid){
            return this.associatedInstitutions[i].title
          }
      }
      return 'N/A'
    }

  },
  computed: {
    ...mapState({
      'packages': state => state.institution.packages,
      'enabledFeatures': state => state.institution.enabledFeatures,
      'institution': state => state.institution.institution,
      'associatedInstitutions': state => state.institution.associatedInstitutions
    }),
    isBookmarkEnabled () {
      let bookmarkFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.BOOKMARK_FEATURE_ID]
      if (bookmarkFeature && bookmarkFeature.enabled) {
        return true
      }
      return false
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/app/explore/components/ProgramGuideItem.vue